import React, { useContext, useEffect } from 'react';
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import "./Tabs.css";


const CustomTabs = ({ tabsData, value, handleChange, useAnyContext = true, contextInfo }) => {
  const context = useContext(contextInfo);

  const changeTab = (event, index) => {
    if (useAnyContext && context) {
      context.setTabIndex(index + 1);
      context.setSortingOrder("part_number");
    }
    handleChange(event, index + 1);
  };

  return (
    <Tabs value={value - 1} onChange={changeTab} className="custom-tab-group">
      {tabsData.map((tab, index) => {
        const countKey = `countView${index + 1}`;
        const countValue = useAnyContext && context?.countSearch ? context.countSearch[countKey] ?? 0 : 0;

        return (
          <Tab
            className="custom-tab"
            key={index}
            label={
              <div className='custom-tab-label'>
                {tab.label}
                {countValue > 0 && <div className="tab-suffix">{countValue}</div>}
              </div>
            }
            icon={tab.icon ? tab.icon : null}
            iconPosition={tab.position}
          />
        );
      })}
    </Tabs>
  );
};

export default CustomTabs;
